function openMenuHandler() {
  const headerNav = document.querySelector(".header__nav");
  const menuBtn = document.querySelector(".mobile-nav-btn");
  const menu = document.querySelector(".header__nav-list");
  const menuBtnIcon = document.querySelector(".nav-icon");

  menuBtn.addEventListener("click", () => {
    menu.classList.toggle("header__nav-list--open");
    menuBtnIcon.classList.toggle("nav-icon--active");
  });

  window.addEventListener("click", (e) => {
    if (!e.composedPath().includes(headerNav)) {
      menu.classList.remove("header__nav-list--open");
      menuBtnIcon.classList.remove("nav-icon--active");
    }
  });
}

export { openMenuHandler };
